import { useState, useEffect } from 'react';
import { useAuth } from './context/AuthContext';
import Layout from './components/Layout/Layout';
import Dashboard from './components/Dashboard/Dashboard';
import UserManagement from './components/UserManagement/UserManagement';
import UploadExcel from './components/UploadExcel/UploadExcel';
import Contacts from './components/Contacts/Contacts';
import Companies from './components/Companies/Companies';
import DncBounce from './components/DncBounce/DncBounce';
import LoginPage from './pages/LoginPage';
import './App.css';

const MODULE_KEY = 'ldm_activeModule';
const TAB_KEY = 'ldm_dncBounceTab';

function App() {
  const { auth } = useAuth();
  const [activeModule, setActiveModule] = useState(() => {
    const saved = localStorage.getItem(MODULE_KEY);
    if (saved && auth) return saved;
    return auth?.role === 'ROLE_USER' ? 'uploadExcel' : 'dashboard';
  });
  const [dncBounceInitialTab, setDncBounceInitialTab] = useState(() => {
    return localStorage.getItem(TAB_KEY) || null;
  });

  // Reset to default module on fresh login (not refresh)
  useEffect(() => {
    if (auth) {
      const saved = localStorage.getItem(MODULE_KEY);
      if (!saved) {
        setActiveModule(auth.role === 'ROLE_USER' ? 'uploadExcel' : 'dashboard');
      }
    } else {
      localStorage.removeItem(MODULE_KEY);
      localStorage.removeItem(TAB_KEY);
    }
  }, [auth]);

  const [domainFilter, setDomainFilter] = useState(null);

  if (!auth) {
    return <LoginPage />;
  }

  const handleModuleChange = (module, extra) => {
    setActiveModule(module);
    localStorage.setItem(MODULE_KEY, module);
    if (module !== 'contacts') setDomainFilter(null);
    if (module === 'dncBounce' && extra?.tab) {
      setDncBounceInitialTab(extra.tab);
      localStorage.setItem(TAB_KEY, extra.tab);
    } else if (module !== 'dncBounce') {
      setDncBounceInitialTab(null);
      localStorage.removeItem(TAB_KEY);
    }
  };

  const handleViewContacts = (domain) => {
    setDomainFilter(domain);
    setActiveModule('contacts');
    localStorage.setItem(MODULE_KEY, 'contacts');
  };

  const renderModule = () => {
    switch (activeModule) {
      case 'dashboard': return <Dashboard onModuleChange={handleModuleChange} />;
      case 'userManagement': return <UserManagement />;
      case 'uploadExcel': return <UploadExcel />;
      case 'contacts':
        return (
          <Contacts
            domainFilter={domainFilter}
            onClearDomainFilter={() => setDomainFilter(null)}
          />
        );
      case 'companies':
        return <Companies onViewContacts={handleViewContacts} />;
      case 'dncBounce': return <DncBounce initialTab={dncBounceInitialTab} />;
      default: return <Dashboard />;
    }
  };

  return (
    <Layout activeModule={activeModule} onModuleChange={handleModuleChange}>
      {renderModule()}
    </Layout>
  );
}

export default App;
